import Vue from 'vue';
import mdiVue from 'mdi-vue/v2';
import * as mdijs from '@mdi/js';

Vue.use(mdiVue, {
  icons: mdijs,
});